import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { UserFragmentDoc } from '../../../../../graphql/fragments/generated/User';
export type EventInstructorFragment = { alias?: string | null, id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null };


export type EventInstructorFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const EventInstructorFragmentDoc = /*#__PURE__*/ gql`
    fragment EventInstructor on UserType {
  ...User
  alias
  orgRole {
    id
    name
  }
}
    `;